export async function getAnnoucements(partition) {
    const url = `${process.env.REACT_APP_API_URL}Announcements/${partition}`;
    const response = await fetch(url, {
        method: "GET",
        credentials: "include",
    })

    if (response.status === 200) {
        return await response.json();
    }
    else if( response.status === 204){
        return [];
    } else {
        throw response.statusText;
    }
}

export async function saveAnnoucement(partition, id, isEnabled, content, productId, order) {
    const url = `${process.env.REACT_APP_API_URL}Announcements/${partition}`;
    const response = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            "id": id,
            "isActive": isEnabled,
            "content": content,
            "productId": productId,
            "order": order
          })
    });

    return response;
}